import React, { useState } from 'react';
import { Box, Typography, Button, Paper, Stack, Divider } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import useAuth from '../hooks/useAuth';
import SignupFlow from './SignupFlow';

// Served markets drive the "we'll reach out as we expand" copy. Kept in
// sync with the `served: true` entries in markets.json — update both.
const SERVED_MARKET_IDS = new Set(['seattle_msa', 'us_remote']);

const hasServedMarket = (markets = []) =>
  markets.some((m) => SERVED_MARKET_IDS.has(m));

const PendingPage = () => {
  const { user, account, handleLogout } = useAuth();
  const [editing, setEditing] = useState(false);

  if (editing) {
    return <SignupFlow editMode onDone={() => setEditing(false)} />;
  }

  const userMarkets = account?.signup_data?.markets || [];
  const servedOverlap = hasServedMarket(userMarkets);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center', p: 3 }}>
      <Paper sx={{ p: 5, maxWidth: 560, textAlign: 'center' }} elevation={2}>
        <Typography variant="h4" gutterBottom>
          You're on the list.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Thanks for signing up. We'll reach out at <b>{user?.email}</b> as we open up access.
        </Typography>
        {!servedOverlap && userMarkets.length > 0 && (
          <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary', fontStyle: 'italic' }}>
            Your target markets are outside our current strongest coverage (Seattle Metro, US Remote).
            We'll reach out as we expand.
          </Typography>
        )}

        <Divider sx={{ my: 3 }} />

        <Stack spacing={1.5} direction="column" alignItems="center">
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            onClick={() => setEditing(true)}
          >
            Review or update your answers
          </Button>
          <Button variant="text" size="small" onClick={handleLogout}>
            Sign out
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default PendingPage;
